import { Controller } from "@hotwired/stimulus";
import debounce from "../lib/debounce";
import Rails from "rails-ujs";

export default class extends Controller {
  static targets = ["submitButton", "trigger"];

  static values = {
    submitOnConnect: Boolean,
    event: String,
    immediate: Boolean,
    delay: Number,
  };

  connect() {
    this.debouncedChangeHandler = debounce(
      (e) => {
        if (e === undefined) return;

        return this.clickSubmitButton();
      },
      this.delayValue || 500,
      this.immediateValue,
    );

    this.triggerElements.forEach((element) => {
      element.addEventListener(this.event, this.debouncedChangeHandler);
    });

    this.element.addEventListener("turbo:submit-end", this.enableElement.bind(this));

    this.cancelPendingSubmit = () => this.debouncedChangeHandler.cancel();
    this.form = this.element.closest("form");
    this.form?.addEventListener("submit", this.cancelPendingSubmit);

    if (this.submitOnConnectValue) {
      this.clickSubmitButton();
    }
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.cancelPendingSubmit);
    this.debouncedChangeHandler.cancel();
  }

  get triggerElements() {
    if (this.hasTriggerTarget) {
      return this.triggerTargets;
    }

    return [this.element];
  }

  get event() {
    if (this.hasEventValue) {
      return this.eventValue;
    }

    return "change";
  }

  clickSubmitButton(e) {
    return this.submitButtonTarget.click();
  }

  clearAndSubmit(event) {
    const target = event.target;
    if (target.value === "") return;

    target.value = "";
    this.clickSubmitButton();
  }

  enableElement() {
    Rails.enableElement(this.element);
  }
}
